export const initialState = () => ({
  client: null,
  ticketsFilters: {},
  tickets: [],
  ticketListPage: 1,
  hasNextTicketPage: false,

  chunks: [], // para paginacion infinita de tickets -- reemplaza a tickets -> [{ cursor, tickets }]
  nextCursor: null, // para paginacion infinita de tickets -- reemplaza next page
  prevCursor: null, // para paginacion infinita de tickets -- reemplaza back page
  channelsChunks: [],

  filteredTickets: [],
  history: null,
  channel_person: null,
  channels: [],
  selectedTickets: [],
  clientsWithSameNumberFound: [],
  clientsFound: [],
  callEnded: false,
  ticketDetail: {},
  dialingType: null,
  speechConfig: { visible: false, portfolio: null },
  portfolioDetail: null,
  typificationsTableData: [],
  isCaptureded: false,
  isSchedule: false,
  lastTicketOpened: {
    ticket: null,
    channel_person: null,
  },
  idTicketDrawerContact: null,
  eventMessaging: null,
  refreshChannelsAsteriskId: null,
  isVisitorTyping: false,
});

const state = initialState();

export default state;
